<template>

    <section
            class="teaser-group"
            v-bind:style="{ backgroundImage: teaserGroupImageUrl }"
    >

        <slot></slot>

    </section>

</template>

<script>

    // console.log('TeaserGroup');

    export default {
        components : {},
        data(){
            return {
                teaserGroupImageUrl : 'url(/media/teaser_group_0.jpg)',
            }
        },
        props : {
            'teaserGroupId' : {
                default : '',
                type : String,
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .teaser-group {
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        /*
        padding-top: 4rem;
        padding-bottom: 8rem;
        @media screen and (min-width: 1200px) {
            padding-top: 4rem * $factor-1200;
            padding-bottom: 8rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            padding-top: 4rem * $factor-1440;
            padding-bottom: 8rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            padding-top: 4rem * $factor-1920;
            padding-bottom: 8rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            padding-top: 4rem * $factor-2400;
            padding-bottom: 8rem * $factor-2400;
        }
        */
    }

</style>
